import { useAuthContext } from '~user-auth/contexts/auth'

export const useAuthDefaultWorkspace = () => {
  const { user } = useAuthContext()

  return user?.defaultWorkspace
}
